import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import Moment from 'react-moment'

import styles from './BlogTeaser.css';
import Button from '../Button/Button';

export default class BlogTeaser extends Component {
  render() {
    const { article } = this.props;

    return (
      <div className={styles.wrapper}>
        <div className={styles.photo} style={{backgroundImage: "url('" + process.env.BLOG_URL + article.thumbnail.url +"')"}}>
        </div>

        <div className={styles.contentWrapper}>
          <span className={styles.date}>Veröffentlicht am <Moment date={article.created_at} format="DD.MM.YYYY" /></span>
          <h4 className={styles.title}><Link to={`/blog/${article.id}`}>{article.title}</Link></h4>

          <div className={styles.content}>
            {article.excerpt}
          </div>

          <Button pullRight href={`/blog/${article.id}`}>Weiter lesen</Button>
        </div>

      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/BlogTeaser/BlogTeaser.js